// extracted by mini-css-extract-plugin
export default {"linkStyledButton":"GsI0QIsxnFJVukDvAwUh"};